{
  "lastUpdatedAt": "2026-06-10T13:30:04.535Z",
  "lastFetchAttemptAt": "2026-06-10T13:30:04.535Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}